const state = {
    profile: {
        id: 0,
        role_id: 0,
        project_id: 0,
        name: '',
        email: '',
        api_token: '',
        api_token_expiration: '',
        channel_id: '',
        projectKey: '',
        project: {
            id: 0,
            bonus: 1
        }
    }
}

const mutations = {
    loginUser (state, payload) {
        state.profile = payload.data
    },

    logOutUser (state) {
        sessionStorage.clear()
        state.profile = {
            id: 0,
            role_id: 0,
            project_id: 0,
            name: '',
            email: '',
            api_token: '',
            api_token_expiration: '',
            projectKey: '',
        }
    }
}

const actions = {}

const getters = {
    getProject: state => state.profile.project,
    getProjectId: state => state.profile.project_id,
    getUserRole: state => state.profile.role_id,
    getUserName: state => state.profile.name,
    getUser: state => state.profile
}

export default {
    state,
    mutations,
    actions,
    getters
}
